import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ConnectEditorPage } from '@/features/editor-access/components/ConnectEditorPage';
import { AI_TOOLS } from '@/features/editor-access/setups';

/** How to connect an AI tool to this app (specs 236, 241). */
export const Route = createFileRoute('/settings/editor')({
  // `?tool=codex` opens that tool's setup, so a teammate can be sent to it.
  validateSearch: z.object({
    tool: z.enum(AI_TOOLS).optional().catch(undefined),
  }),
  component: ConnectEditorRoute,
});

export function ConnectEditorRoute() {
  const { tool } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ConnectEditorPage
      tool={tool}
      onToolChange={(next) => {
        // Replaced, not pushed: switching tabs is not a step Back should undo.
        void navigate({
          search: { tool: next === 'claude-code' ? undefined : next },
          replace: true,
        });
      }}
    />
  );
}
